import { render } from "./ModalPaymentEfectivo.vue?vue&type=template&id=1db5a298&scoped=true"
import script from "./ModalPaymentEfectivo.vue?vue&type=script&lang=js"
export * from "./ModalPaymentEfectivo.vue?vue&type=script&lang=js"

import "./ModalPaymentEfectivo.vue?vue&type=style&index=0&id=1db5a298&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db5a298"]])

export default __exports__